import { render, staticRenderFns } from "./Tab-IIIa.vue?vue&type=template&id=980eef4a"
import script from "./Tab-IIIa.vue?vue&type=script&lang=js"
export * from "./Tab-IIIa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports